// A tiny module singleton holding the currently-focused Monaco editor, so chrome
// outside the editor (the menu bar's Edit/Selection/Go items) can drive it
// without threading the instance through React state. Deliberately NOT in the
// zustand store: holding a live editor instance there would churn renders and it
// is not serializable.

import type { editor as MonacoEditor } from "monaco-editor";

let current: MonacoEditor.IStandaloneCodeEditor | null = null;

export function setActiveEditor(ed: MonacoEditor.IStandaloneCodeEditor | null): void {
  current = ed;
}

export function getActiveEditor(): MonacoEditor.IStandaloneCodeEditor | null {
  return current;
}

/** Focus the editor and run a registered action (e.g. "actions.find"), or fall
 *  back to a built-in command trigger (e.g. "undo"). No-op if no editor. */
export function runEditorCommand(idOrAction: string, viaTrigger = false): void {
  const e = current;
  if (!e) return;
  e.focus();
  if (viaTrigger) {
    e.trigger("menu", idOrAction, null);
    return;
  }
  const action = e.getAction(idOrAction);
  if (action) action.run();
  else e.trigger("menu", idOrAction, null);
}
